import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type PartJsonDto = ClientInferResponseBody<typeof contract.parts.getPartJson>;
export const fetchPartJson = async (id: string): Promise<PartJsonDto> => {
  const response = await api.parts.getPartJson.query({ params: { id } });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
